import React from 'react';
import { motion } from 'framer-motion';
const yesItems = ['Tienes un hijo de entre 10 y 18 años', 'Sientes que la comunicación se ha roto', 'Quieres entender antes de juzgar', 'Buscas herramientas prácticas, no teoría vacía', 'Estás dispuesto/a a mirarte a ti mismo también', 'Quieres que tu hijo te vea como aliado, no como enemigo'];
const noItems = ['Buscas fórmulas mágicas de obediencia instantánea', 'No estás dispuesto/a a cambiar ningún hábito propio', 'Crees que la crianza es solo responsabilidad del colegio', 'Quieres un hijo perfecto, no una relación real', 'No tienes tiempo para leer 45 páginas que pueden cambiarlo todo'];
export function ForWhomSection() {
  return <section className="py-20 px-5 bg-white" data-id="element-87">
      <div className="max-w-4xl mx-auto" data-id="element-88">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl text-[#1A2744] text-center mb-12" data-id="element-89">
          ¿Esta Guía es Para Ti?
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-90">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-91">
            <h3 className="text-base font-bold text-[#38A169] mb-5 pb-3 border-b-2 border-[#38A169]" data-id="element-92">
              ✅ SÍ es para ti si...
            </h3>
            <ul className="space-y-3" data-id="element-93">
              {yesItems.map((item, index) => <li key={index} className="flex items-start gap-3 text-[#4A5568] text-sm py-2 border-b border-[#F0F4F0]" data-id="element-94">
                  <span className="text-base text-[#38A169] flex-shrink-0 mt-0.5" data-id="element-95">
                    ✅
                  </span>
                  <span data-id="element-96">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-97">
            <h3 className="text-base font-bold text-[#E53E3E] mb-5 pb-3 border-b-2 border-[#E53E3E]" data-id="element-98">
              ❌ NO es para ti si...
            </h3>
            <ul className="space-y-3" data-id="element-99">
              {noItems.map((item, index) => <li key={index} className="flex items-start gap-3 text-[#4A5568] text-sm py-2 border-b border-[#F0F4F0]" data-id="element-100">
                  <span className="text-base text-[#E53E3E] flex-shrink-0 mt-0.5" data-id="element-101">
                    ❌
                  </span>
                  <span data-id="element-102">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}